// REF: https://clerk.com/docs/custom-flows/oauth-connections
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

import { addTrackCrumb } from '../../error/tracking';
import { appendUtmQueryString } from '../../shared/utm';

export const Route = createFileRoute('/auth/oauthcb')({
  beforeLoad: function () {
    addTrackCrumb({
      category: 'route',
      message: '/auth/oauthcb',
      level: 'info',
    });
    addTrackCrumb({
      category: 'auth',
      message: 'inside oauthcb',
      level: 'info',
    });
  },
  // eslint-disable-next-line no-use-before-define
  component: Oauthcb,
});

function Oauthcb() {
  const completeSignLocation = appendUtmQueryString('/auth/wait-user');

  return (
    <AuthenticateWithRedirectCallback
      signUpFallbackRedirectUrl={completeSignLocation}
      signUpForceRedirectUrl={completeSignLocation}
    />
  );
}
